import styled from 'styled-components';

const ErrorLandingPageWrapper = styled.div`
align-content: center;
display: flex;
flex-direction: column;
font-family:font-family: ${(props) => props.theme.font.family};
justify-content: center;
margin: 0 auto;
min-height: 500px;
padding: 24px;
text-align:center;
width: 100%;

& svg{
  margin:0 auto;
  display:flex; 
  margin-bottom:27px;
}

@media (min-width: ${(props) => props.theme.breakpoint.md}px) {
  max-width: 1800px;
  margin: 0 auto;
  padding: 40px 100px;
}

@media (min-width: ${(props) => props.theme.breakpoint.lg}px) {
  margin: 0 auto;
  max-width: 1800px;
  min-height: 500px;
  padding: 40px 200px;
}
`;

const HeaderMessage = styled.div`
  ${(props) => props.theme.font.heading.v100};
  color: ${(props) => props.theme.color.primary.v600};
  font-size: 28px;
  font-weight: ${(props) => props.theme.font.weight.v300};
  line-height: 32px;
  margin-bottom: 16px;
`;

const ErrorMessage = styled.div`
  color: #757990;
  font-size: 16px;
  line-height: 24px;
  margin: 0 auto;
  word-break: break-word;
`;

const Spacer = styled.div`
  min-height: 15px;
`;

export { ErrorLandingPageWrapper, HeaderMessage, ErrorMessage, Spacer };
